import axios from 'axios'

import { downloadFromS3 } from './helpers'
import { InvalidAPIResponse } from '@SonarCX/errors'

// Helper method for creating the request header for widget requests
const getHeaders = () => {
  const headers = {
    'X-User-Account-Id': 'demo0000'
  }

  return { headers }
}

// Helper method for GET that sets the correct headers
const callGet = async (uri: string) => {
  return axios.get(uri, getHeaders())
}

// Wraps a call to the appropriate method in a generic error handler
const wrapCall = async ({
  method,
  uri,
  data = null,
  rawError = false,
  noData = false
}) => {
  try {
    const response = await method(`https://hal9000.sonarcx.com${uri}`, data)

    if (noData) {
      return response.data
    }

    return response.data?.data ?? null
  } catch (err) {
    if (rawError) {
      throw err
    } else {
      throw new InvalidAPIResponse(err.message, err)
    }
  }
}

// Gets an article by spoofing widget headers
export const getWidgetArticle = async (id: string) => {
  return await wrapCall({ method: callGet, uri: `/articles/${id}` })
}

// Gets the S3 media from media id
export const getWidgetMedia = async (id: string) => {
  let signedUrl: string
  await axios({
    method: 'GET',
    url: `https://hal9000.sonarcx.com/media/${id}/download`,
    ...getHeaders()
  }).catch(e => {
    signedUrl = e.response.headers['x-location']
  })

  return await downloadFromS3(signedUrl)
}
